import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Homepage} from "./pages/Homepage";
import './index.css'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import { WebkitDetailsPage } from './pages/webkitDetails';
import { DesignkitDetailsPage } from './pages/designkitDetails';
import { MobilkitDetailsPage } from './pages/mobilkitDetails'
import { CloudkitDetailsPage } from './pages/cloudkitDetails'
import { MarketkitDetailsPage } from './pages/marketkitDetails'
import { TestkitDetailsPage } from './pages/testkitDetails'


function App() {
  return (
    <>
    <Router>
      <Switch>
      <Route path='/' exact component={Homepage} />
      <Route path='/webkitDetails' exact component={WebkitDetailsPage} />
      <Route path='/designkitDetails' exact component={DesignkitDetailsPage} />
      <Route path='/mobilkitDetails' exact component={MobilkitDetailsPage} />
      <Route path='/cloudkitDetails' exact component={CloudkitDetailsPage} />
      <Route path='/marketkitDetails' exact component={MarketkitDetailsPage} />
      <Route path='/testkitDetails' exact component={TestkitDetailsPage} />
      </Switch>
    </Router>
    </>
  );
}

export default App;
